'use strict'

module.exports = hardBreak

var u = require('unist-builder')

/* Transform an inline break. */
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')]
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/break.js
// module id = 887
// module chunks = 95715928098905 168707334958949